import React, { useEffect, useState } from "react";
// import { ScrollMenu, VisibilityContext, } from 'react-horizontal-scrolling-menu';
// import Arrow from 'react-arrows'
import { Container, Grid, Paper } from "@material-ui/core";

// import { useNavigate } from 'react-router-dom'
import StoreCard from "../cards/StoreCard";
// import List from '@mui/material/List';

import Divider from "@mui/material/Divider";

export function StoreList(props) {
  // const nav = useNavigate();
  const [stores, setStores] = React.useState([]);
  const delivery_id = props.delivery_id;
  var dedmo = props.flag;

  useEffect(() => {
    setStores(props.list);
  });
  // const handleClick =
  //     (id) =>
  //         ({ getItemById, scrollToItem }) => {
  //             console.log('id is', id)
  //             var my_item = stores.filter((store) => {
  //                 return store._id == id
  //             })
  //             console.log(my_item)
  //             // nav(`/store/${id}`, my_item);
  //         };

  // return (
  //     <List sx={{ width: '100%', bgcolor: 'background.paper', margin: 'auto', marginTop: '3px' }} >

  //         {stores.map((item) => (

  //             // <Grid item key={item._id} xs={12} md={6} lg={3}>
  //                <div key={item._id}>
  //                     <StoreCard store={item} delivery_id={delivery_id} flag={dedmo} />
  //                     {stores.length == 1 ? null : <Divider variant="inset" component="li" />}

  //                 </div>
  //            // </Grid>
  //         ))}
  //     </List>
  // );
  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
        margin: "auto",
        marginTop: "8px",
      }}
    >
      <Container>
        <Grid container spacing={1}>
          {stores.map((item) => (
            <Grid item key={item._id} xs={12} sm={6} md={4} lg={3}>
              <StoreCard store={item} delivery_id={delivery_id} flag={dedmo} />
              {stores.length <= 3 ? null : <Divider variant="inset" />}
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
